<form [formGroup]="messageReplyForm" aria-label="message-reply-form">
    <div class="w-12 mx-auto z-2 border-round-xl border-noround-bottom surface-0 border-1 border-bottom-none border-primary" aria-label="reply-container">
        <p-select [options]="RepliesFrom | async" formControlName="reply_from" optionLabel="name" optionDisabled="isCorporate" styleClass="w-full text-sm shadow-none border-none border-round-xl border-noround-bottom" (onChange)="OnSenderChange($event, true)" aria-label="reply-channel-dropdown">
            <ng-template pTemplate="selectedItem">
                <div *ngIf="SelectedReplyFrom.value" class="text-sm flex align-items-center" aria-label="selected-reply-channel">
                    <span class="{{SelectedReplyFrom.value.color}} text-white flex align-items-center justify-content-center p-1 border-round" aria-label="channel-icon">
                        <i class="{{SelectedReplyFrom.value.icon}}"></i>
                    </span>
                    <strong class="font-bold ml-2 mr-3" aria-label="channel-name">
                        <span class="hidden md:inline">{{ 'CLIENT_INTERACTION.REPLY_WITH' | translate }}</span> {{SelectedReplyFrom.value.name}} ({{ SelectedReplyFrom.value.sender }})
                    </strong>
                    <i *ngIf="SelectedReplyFrom.value.name.toLowerCase() ==='whatsapp'" class="fa fa-circle text-xxs" [ngClass]="showDotColor" aria-label="whatsapp-status"></i>
                </div>
            </ng-template>
            <ng-template let-reply pTemplate="item">
                <div class="text-sm flex align-items-center" [attr.aria-label]="'reply-option-' + reply.name.toLowerCase()">
                    <span class="{{reply.color}} text-white flex align-items-center justify-content-center p-1 border-round" [attr.aria-label]="reply.name + '-icon'">
                        <i class="{{reply.icon}}"></i>
                    </span>
                    <strong class="font-normal ml-2 mr-3">{{reply.name}} ({{ reply.sender }}) {{reply.isCorporate ? '(Corporate)' : ''}}</strong>
                    <i *ngIf="reply.name.toLowerCase() === 'whatsapp'" class="fa fa-circle text-xxs" [ngClass]="showDotColor" [attr.aria-label]="reply.name + '-status'"></i>
                </div>
            </ng-template>
        </p-select>
        <input
            *ngIf="SelectedReplyFrom.value && SelectedReplyFrom.value.name.toLocaleLowerCase() === 'email' "
            type="text"
            formControlName="subject"
            class="w-full text-sm border-none border-noround border-top-1 border-300 shadow-none"
            pInputText
            placeholder="Add Subject"
            aria-label="email-subject-input"
        />
        <div class="relative border-top-1 border-300" aria-label="message-editor-container">
            <p-editor [style]="{'height':'90px'}" formControlName="content" [readonly]="bodyreadOnly" (ngModelChange)="Updatevalue($event)" (keydown)="handleKeyboardShortcut($event)"  [ngClass]="{ 'ng-invalid ng-dirty': Content.invalid && Content.touched }" #editor aria-label="message-content-editor">
            </p-editor>
            <div class="flex align-items-center absolute right-0 bottom-0 mr-3 mb-3 z-1" aria-label="editor-actions">
                <i (click)="chooseTemplates=true" class="fa fa-file-lines text-700 cursor-pointer mr-3" pTooltip="Choose Templates" tooltipStyleClass="text-xs" aria-label="choose-templates-button"></i>
                <i class="fa fa-paper-plane text-primary cursor-pointer" (click)="SendMessage()" [ngClass]="{'pointer-events-none opacity-50': !messageReplyForm.valid}" aria-label="send-message-button"></i>
            </div>
        </div>
    </div>
</form>

<!-- Choose Templates Modal  -->
<p-dialog [(visible)]="chooseTemplates" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '600px'}" styleClass="no-header-modal" aria-label="choose-templates-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Header -->
    <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300" aria-label="dialog-header">
    <h2 class="mb-0 text-sm" aria-label="dialog-title">{{'CLIENT_INTERACTION.CHOOSE_TEMPLATE' | translate}}</h2>
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="chooseTemplates = false" aria-label="close-dialog-button"></i>
    </div>
    <!-- Header -->

    <!-- Search Templates -->
    <div class="p-3 text-sm border-bottom-1 border-300 flex align-items-center relative" aria-label="search-container">
        <i class="fa fa-search text-600 absolute left-0 ml-4" aria-label="search-icon"></i>
        <input 
            pInputText 
            type="text" 
            class="w-full text-sm pl-5" 
            placeholder="{{'CLIENT_INTERACTION.SEARCH_TEMPLATES' | translate}}"
            [ngModel]="searchQuery"
            (input)="filterTemplates($event)"
            aria-label="search-templates-input">
    </div>
    <!-- Search Templates -->

    <!-- Email Templates -->
     <div class="py-3" aria-label="templates-section">
    <h4 class="text-sm line-height-1 mb-3 px-3">{{ this.SelectedReplyFrom.value.name.toLowerCase() === 'email' ? ('CLIENT_INTERACTION.EMAIL_TEMPLATES' | translate) : (this.SelectedReplyFrom.value.name.toLowerCase() === 'sms' ? ('CLIENT_INTERACTION.SMS_TEMPLATES' | translate) : ('CLIENT_INTERACTION.WHATSAPP_TEMPLATES' | translate))}} ({{filteredTemplateList.length}})</h4>


    <p-table [value]="filteredTemplateList" styleClass="p-0" responsiveLayout="scroll" aria-label="templates-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="surface-100 border-bottom-none font-bold" aria-label="template-name-header"><span class="text-xs text-600 white-space-nowrap">{{'CLIENT_INTERACTION.TEMPLATE_NAME' | translate}}</span></th>
            <th class="surface-100 border-bottom-none font-bold" aria-label="actions-header"><span class="text-xs text-600 white-space-nowrap"></span></th>
            <th class="surface-100 border-bottom-none font-bold"><span class="text-xs text-600 white-space-nowrap"></span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-template>
          <tr class="text-sm hover:surface-100" [attr.aria-label]="'template-row-' + template.name_primary_language">
            <td class="py-3" [attr.aria-label]="'template-name-' + template.name_primary_language">{{template.name_primary_language}}</td>
            <td class="py-3"><p-button label="{{'CLIENT_INTERACTION.USE' | translate}}" styleClass="text-sm" (onClick)="OnTemplateSelect(template)" [attr.aria-label]="'use-template-' + template.name_primary_language"></p-button></td>
          </tr> 
        </ng-template>
      </p-table>
     </div>
    <!-- Email Templates -->

  </ng-template>

</p-dialog>
<!-- Choose Templates Modal -->
